import config from '../../config';

const getErrorMessage = (e, messages) =>
    messages[e?.code] ?? messages.default ?? e?.message ?? 'Failed create subscription';

const handleCreateSubscriptionError = (e, messages = {}, localePrefix = '') => {
    const message = getErrorMessage(e, messages);

    if (e?.code === 'planFeaturesAreAlreadyProvided') {
        if (window.confirm(message)) {
            window.location.href = `${config.platformUrl}${localePrefix}/sign-in`;
        }
    } else {
        alert(message);
    }
};

export {
    handleCreateSubscriptionError
};
